import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { getUser } from '../../../Auth/AuthReducer';
import piPermissions from '../../../../components/pi-permission';
import OrganizationPage from '../OrganizationPage/OrganizationPage';
import AdminUserPage from '../OrganizationAdminPage/OrganizationAdminPage';
import NewsPage from '../NewsPage/NewsPage';
import PiUserPage from '../PIUserPage/PIUserPage';
import ClientStatsPage from '../ClientStatsPage/ClientStatsPage';
import ReportPage from '../ReportPage/ReportPage';
import EmergencyStopPage from '../EmergencyStopPage/EmergencyStopPage';

function AdminPage(props) {
  const { user, location: { pathname } } = props;
  const isAdmin = user.role && (user.role === 'superadmin' || user.role === 'admin');
  return (
    <div>
      <Helmet title="TruVoice Automation Control Panel" />
      <div className="container">
        <h1 className="page-header">TruVoice Automation Control Panel</h1>
        <ul className="nav nav-tabs">
          <LinkContainer to="/admin/organizations">
            <NavItem>All Organizations</NavItem>
          </LinkContainer>
          {isAdmin && <LinkContainer to="/admin/pi-users">
            <NavItem>TruVoice by Corporate Visions Users</NavItem>
          </LinkContainer>}
          {isAdmin && <LinkContainer to="/admin/admin-users">
            <NavItem>Organization Admins</NavItem>
          </LinkContainer>}
          {isAdmin && <LinkContainer to="/admin/news">
            <NavItem>Announcements</NavItem>
          </LinkContainer>}
          {isAdmin && <LinkContainer to="/admin/client-stats">
            <NavItem>Client Stats</NavItem>
          </LinkContainer>}
          {isAdmin && <LinkContainer to="/admin/reports">
            <NavItem>Reports</NavItem>
          </LinkContainer>}
          {isAdmin && <LinkContainer to="/admin/emergency-stop">
            <NavItem>Emergency Stop</NavItem>
          </LinkContainer>}
        </ul>
      </div>
      <Switch>
        <Route path="/admin/organizations" component={OrganizationPage} />
        <Route path="/admin/pi-users" component={PiUserPage} />
        <Route path="/admin/admin-users" component={AdminUserPage} />
        <Route path="/admin/news" component={NewsPage} />
        <Route path="/admin/client-stats" component={ClientStatsPage} />
        <Route path="/admin/reports" component={ReportPage} />
        <Route path="/admin/emergency-stop" component={EmergencyStopPage} />
        {(pathname === '/admin' && <Redirect to="/admin/organizations" />)}
      </Switch>
    </div>
  );
}
// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

AdminPage.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  location: PropTypes.object.isRequired,
};

AdminPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(piPermissions(AdminPage, 'superadmin', 'admin', 'pi')));
